/**
 * Hronološka obaveštenja od super admina — od lansiranja (19.08.2025) do danas.
 * Korisnik od današnjeg dana dodaje nova obaveštenja preko super admin panela.
 */
const FEATURE_TIMELINE_ITEMS = [
  {
    id: 'launch-welcome',
    title: 'Dobrodošli u SpinTasker!',
    message: `SpinTasker je zvanično pokrenut 19. avgusta 2025.

Ovo je vaš centralni sistem za upravljanje terenskim servisom — poslovi, klijenti, radnici i kalendar na jednom mestu.

Šta možete odmah:
• Prijavite se i popunite podatke kompanije u Profilu
• Dodajte prvog radnika u sekciji Radnici
• Kreirajte prvi posao u kalendaru — klijent se automatski dodaje prilikom kreiranja posla (ime, telefon, adresa)

Savet za početak: posle svakog novog poziva odmah otvorite Kalendar i unesite posao. Ne morate prvo posebno da unosite klijenta — dovoljno je da pri kreiranju posla popunite njegove podatke i sistem će ga sačuvati u bazi.`,
    type: 'success',
    category: 'Početak',
    createdAt: '2025-08-19T09:00:00+02:00'
  },
  {
    id: 'feature-calendar-jobs',
    title: 'Kako dodati posao u kalendar',
    message: `Kalendar je srce aplikacije. Evo korak po korak kako da zakažete posao:

1. Idite na Akcija → Poslovi ili direktno na Kalendar
2. Kliknite na „Novi posao" ili na željeni datum u kalendaru
3. Popunite obavezna polja:
   • Klijent (izaberite postojećeg ili unesite novog — klijent se automatski dodaje u bazu)
   • Datum i vreme servisa
   • Opis kvara / usluge
   • Prioritet (Normalan, Visok, Hitno)
4. Dodelite radnika iz padajuće liste
5. Sačuvajte — posao se pojavljuje u kalendaru i na listi poslova

Šta još uključuje ova funkcionalnost:
• Pregled po danu, nedelji i mesecu
• Bojama označeni prioriteti i statusi
• Filter po radniku, partneru i prioritetu

Savet: za hitne pozive odmah označite prioritet „Hitno" — tim će dobiti vizuelno upozorenje.`,
    type: 'info',
    category: 'Kalendar',
    createdAt: '2025-09-03T10:00:00+02:00'
  },
  {
    id: 'feature-clients',
    title: 'Upravljanje klijentima (CRM)',
    message: `Sekcija Klijenti je vaša baza podataka o strankama.

Kako dodati klijenta:
1. Akcija → Klijenti → „Novi klijent"
2. Unesite ime, telefon, email i adresu
3. Opciono: napomene, tip uređaja, istorija poziva

Šta možete raditi:
• Pregled svih klijenata sa pretragom i filterima
• Istorija svih poslova po klijentu
• Brzo kreiranje novog posla direktno iz profila klijenta
• Kontakt podaci uvek pri ruci prilikom zakazivanja
• Klijent može biti ocenjen radi budućih promocija

Savet: uvek unesite bar jedan telefon — radnici na terenu mogu odmah pozvati bez traženja po beleškama.`,
    type: 'info',
    category: 'Klijenti',
    createdAt: '2025-09-08T11:00:00+02:00'
  },
  {
    id: 'feature-workers',
    title: 'Radnici i dodela poslova',
    message: `Radnici su terenski tim koji izvršava poslove.

Kako dodati radnika:
1. Akcija → Radnici → „Dodaj radnika"
2. Unesite ime, telefon, email i specijalizaciju
3. Podesite pristupne podatke za mobilnu aplikaciju radnika

Dodela posla:
• Pri kreiranju posla izaberite radnika iz liste
• Ili kasnije: otvorite posao → promenite dodeljenog radnika
• Radnik dobija posao u svojoj mobilnoj aplikaciji u realnom vremenu

Dodatno:
• Pregled opterećenja po radniku u kalendaru
• Filter kalendara po radniku
• Status radnika (slobodan, na poslu, na putu)
• Rejting radnika — algoritam koliko koji radnik doprinosi
• Izostanak radnika u kalendaru (godišnji odmor, bolovanja, slobodni dani)`,
    type: 'info',
    category: 'Radnici',
    createdAt: '2025-09-12T14:00:00+02:00'
  },
  {
    id: 'feature-status-tracking',
    title: 'Praćenje statusa posla i radnika',
    message: `Statusi vam daju uvid šta se dešava na terenu u svakom trenutku.

Statusi posla:
• Primljen → Na čekanju → Dodeljen → Na putu → Na lokaciji → U radu → Završen

Statusi radnika:
• Slobodan, Na putu, Na poslu, Pauza, Offline

Kako koristiti:
1. Otvorite Akcija → Status za pregled svih radnika
2. Kliknite na radnika za detalje aktivnog posla
3. Promene statusa radnik šalje iz mobilne aplikacije — vi vidite odmah

Prednosti:
• Dispečer zna ko je gde bez telefonskih poziva
• Vreme putovanja i rada se automatski meri
• Istorija statusa ostaje u arhivi posla`,
    type: 'warning',
    category: 'Status',
    createdAt: '2025-09-19T14:15:00+02:00'
  },
  {
    id: 'feature-services',
    title: 'Usluge i cenovnik',
    message: `Definišite standardne usluge koje nudite — ubrzava kreiranje poslova i fakturisanje.

Kako podesiti:
1. Akcija → Usluge → „Nova usluga"
2. Unesite naziv, opis, cenu i trajanje
3. Povežite sa tipom uređaja ako je potrebno

Koristi se pri:
• Brzom kreiranju posla (izbor usluge popunjava polja)
• Paketima i fiksnim cenama
• Izveštajima o prihodima po vrsti usluge`,
    type: 'info',
    category: 'Usluge',
    createdAt: '2025-09-25T09:30:00+02:00'
  },
  {
    id: 'feature-live-view',
    title: 'Live pregled — šta se dešava sada',
    message: `Live sekcija prikazuje aktivne poslove i radnike u realnom vremenu.

Šta vidite:
• Ko je trenutno na putu ili na poslu
• Aktivni tajmeri putovanja i rada
• Mapu lokacija (ako je adresa uneta)
• Poslednju aktivnost svakog radnika

Kada koristiti:
• Ujutru — raspored dana i ko je već krenuo
• Tokom dana — praćenje kašnjenja i preusmeravanje
• Hitne intervencije — pronađite najbližeg slobodnog radnika`,
    type: 'info',
    category: 'Live',
    createdAt: '2025-10-07T10:00:00+02:00'
  },
  {
    id: 'feature-logo-spin',
    title: 'Logo @',
    message: `Znak @ u logou (Manki) pokazuje koliko je servis opterećen. Okreće se brže kada ima više otvorenih poslova po radniku i partneru.

Kako se računa brzina:
• Broje se otvoreni poslovi — u kalendaru, nezakazani i prosleđeni
• Taj broj se deli brojem aktivnih radnika i partnera
• 15 poslova po osobi = 1 krug u 60 sekundi
• 30 poslova po osobi = 1 krug u 30 sekundi
• 60 poslova po osobi = 1 krug u 15 sekundi
• 90 poslova po osobi = 1 krug u 10 sekundi
• Nema otvorenih poslova = spor krug od 120 sekundi

Gde to vidite: Dashboard — kartica Manki @. Tu možete i zaustaviti ili ponovo pokrenuti okretanje.

Što je veće opterećenje, to se @ brže okreće. Završavajte poslove na vreme da ritam ostane miran.`,
    type: 'info',
    category: 'Dashboard',
    createdAt: '2025-10-09T10:00:00+02:00'
  },
  {
    id: 'feature-calendar-nesting',
    title: 'Kalendar na svim ekranima',
    message: `Kalendar je sada dostupan kao ugnježdeni prikaz bilo gde u aplikaciji.

Šta je novo:
• Otvaranje kalendara iz bilo koje sekcije bez gubljenja konteksta
• Brzi pregled današnjih poslova dok radite u drugim modulima
• Konzistentan izgled na desktopu i mobilnom uređaju

Kako otvoriti: kliknite na ikonu kalendara u gornjoj traci ili u bočnom meniju.`,
    type: 'info',
    category: 'Kalendar',
    createdAt: '2025-10-03T09:20:00+02:00'
  },
  {
    id: 'feature-archive',
    title: 'Arhiva završenih poslova',
    message: `Svi završeni poslovi automatski prelaze u arhivu.

U arhivi možete:
• Pretraživati po klijentu, datumu, radniku
• Pregledati kompletnu istoriju intervencije
• Videti utrošeno vreme, delove i napomene
• Izmeniti podatke ukoliko su pogrešno sačuvani
• Ponovo otvoriti posao ako je potreban povratni servis

Arhiva je važna za garancije, reklamacije i analizu rada tima.`,
    type: 'info',
    category: 'Arhiva',
    createdAt: '2025-10-14T11:00:00+02:00'
  },
  {
    id: 'feature-client-history',
    title: 'Istorija klijenta',
    message: `Svaki klijent ima kompletnu istoriju rada na jednom mestu — bez pretrage po arhivi i kalendaru.

Kako otvoriti:
1. Akcija → Klijenti
2. Kliknite na klijenta da otvorite istoriju
3. Pregledajte podatke i sve dosadašnje popravke

Šta vidite:
• Kontakt (telefon, email, adresa) i ocenu klijenta
• Istoriju popravki — aktivni i arhivirani poslovi
• Uređaj, opis kvara, status i datum
• Dodeljenog radnika, naplatu, materijal i zaradu
• Ocenu sa terena, ako je uneta

Šta možete odmah:
• Pozvati klijenta jednim klikom
• Otvoriti novi posao za istog klijenta — podaci se prepisuju automatski

Savet: pre novog izlaska otvorite istoriju. Videćete šta je već rađeno, koji je uređaj i da li klijent zaslužuje promociju na osnovu ocene.`,
    type: 'success',
    category: 'Klijenti',
    createdAt: '2025-10-21T16:40:00+02:00'
  },
  {
    id: 'feature-storage',
    title: 'Magacin i zalihe',
    message: `Pratite delove i materijal na lageru.

Osnovni tok:
1. Kompanija → Magacin → unos artikala
2. Definišite šifru, naziv, količinu i cenu
3. Pri izdavanju na posao — automatsko smanjenje zaliha
4. Upozorenje kada zaliha padne ispod minimuma

Povezano sa: Rezervnim delovima, Web prodavnicom, Fakturama.`,
    type: 'info',
    category: 'Magacin',
    createdAt: '2025-10-28T09:00:00+02:00'
  },
  {
    id: 'feature-timer-start',
    title: 'Tajmer za početak radova',
    message: `Na poslu postoje dva tajmera: za start putovanja i za start rada.

Kako radi:
• Radnik klikne „Kreni" — pokreće se tajmer putovanja (koliko traje odlazak do klijenta)
• Klikom na „Start Rad" pokreće se tajmer rada (koliko traje intervencija)
• Dispečer vidi oba tajmera uživo
• Vreme puta i rada ostaje u evidenciji posla i arhivi

Ne može se istovremeno voditi putovanje ili rad na dva posla — prvo se završi ili zaustavi aktivni tajmer.`,
    type: 'info',
    category: 'Poslovi',
    createdAt: '2025-11-05T11:05:00+02:00'
  },
  {
    id: 'feature-parking',
    title: 'Podsetnik za parking',
    message: `Kada radnik stigne na adresu i startuje rad, automatski stiže podsetnik o uplati parkinga — da ne zaboravi ukoliko je u parking zoni.

Kako radi:
• Radnik klikne „Start Rad"
• Odmah se pojavljuje podsetnik: „Da li ste uplatili parking?"
• Potvrdi uplatu ili nastavi ako parking nije potreban
• Tek tada kreće tajmer rada

Podsetnik je tu da se parking ne preskoči u žurbi, posebno u zonama sa naplatom.`,
    type: 'warning',
    category: 'Notifikacije',
    createdAt: '2025-11-12T10:00:00+02:00'
  },
  {
    id: 'feature-notification-bell',
    title: 'Centar notifikacija (zvonce)',
    message: `Ikona zvona u gornjoj traci prikazuje sve važne događaje.

Tipovi obaveštenja:
• Promena statusa posla
• Parking podsetnici
• Hitni poslovi
• Poruke od super admina (ova sekcija)

Filtrirajte po: Sve, Nepročitane, Parking. Označite sve kao pročitano jednim klikom.`,
    type: 'info',
    category: 'Notifikacije',
    createdAt: '2025-11-18T15:00:00+02:00'
  },
  {
    id: 'feature-partners',
    title: 'Servisni partneri',
    message: `Servisni partneri su firme koj rade poslove za vas — podeservisi. Dodajete ih u bazu, pa im prosleđujete nalog kada vaš tim ne ide na teren.

Odnos servisni partner — podeservis:
• Servisni partner je firma u vašoj listi partnera (kontakt, dogovor, evidencija)
• Podeservis je taj isti partner na konkretnom poslu — njemu prosleđujete izvršenje
• Vi ostajete centralni servis prema stranci; podeservis izvršava intervenciju svojim radnikom

Kako radi:
1. Akcija → Partneri — unesite firmu i kontakt
2. Na poslu dodelite servisnog partnera
3. Ako je partner na SpinTasker-u, posao mu stiže u Nezakazane poslove i na mejl
4. Ako partner nije registrovan u SpinTasker-u, posao mu stiže samo na mejl
5. Registrovani partner prihvata ili odbija — vi to vidite odmah
6. Kad zakazuje i završava, termin i status se pojavljuju i vama, bez telefonskih krugova

Možete podesiti procenat ili fiksni deo od cene popravke. I obrnuto: partner može vama da pošalje posao koji ne može da završi (deo, alat, brend, zona).`,
    type: 'info',
    category: 'Servisni partneri',
    createdAt: '2025-11-25T09:00:00+02:00'
  },
  {
    id: 'feature-vehicles',
    title: 'Vozila servisa',
    message: `Registrujte vozila tima i povežite ih sa radnicima.

Šta unosite:
• Marka, model, registarska oznaka
• Dodeljeni radnik / ekipa
• Servisni intervali i napomene

Koristi se za planiranje ruta, kilometražu i evidenciju troškova goriva.`,
    type: 'info',
    category: 'Vozila',
    createdAt: '2025-12-03T11:00:00+02:00'
  },
  {
    id: 'feature-spare-parts',
    title: 'Rezervni delovi',
    message: `Ako delove nabavljate pojedinačno u maloprodaji i želite uvid u zalihe, u ovoj sekciji vidite stanje u magacinu.

Namenjeno korisnicima koji poslove obavljaju tako što ugrađeni delovi ne prolaze kroz matičnu kompaniju — delovi se obično skladište u automobilima.

Šta pratite:
• Koji deo je u kom vozilu / kod kog radnika
• Šta je ugrađeno na poslu
• Trenutno stanje bez centralnog magacina firme`,
    type: 'info',
    category: 'Magacin',
    createdAt: '2025-12-10T10:00:00+02:00'
  },
  {
    id: 'feature-webshop',
    title: 'Web prodavnica',
    message: `Pokrenite online prodavnicu delova i usluga. Ova opcija je dostupna u paketu Business.

Koraci:
1. Kompanija → Web Shop → aktivirajte prodavnicu
2. Dodajte proizvode iz magacina
3. Podesite cene, slike i opise
4. Podelite link klijentima

Integrisano sa zalihama — prodaja automatski ažurira stanje u magacinu.`,
    type: 'success',
    category: 'Web Shop',
    createdAt: '2025-12-17T14:00:00+02:00'
  },
  {
    id: 'feature-analytics',
    title: 'Analitika i izveštaji',
    message: `Donosite odluke na osnovu podataka.

Dostupni izveštaji:
• Broj poslova po periodu, radniku, statusu
• Prihodi i prosečno vreme po intervenciji
• Najčešći kvarovi i usluge
• Performanse tima — ko završava najviše poslova

Kompanija → Analitika. Filtrirajte po datumu i izvezite podatke.`,
    type: 'info',
    category: 'Analitika',
    createdAt: '2026-01-08T10:00:00+02:00'
  },
  {
    id: 'feature-marketing-sms',
    title: 'SMS marketing i podsetnici',
    message: `Šaljite SMS poruke klijentima iz aplikacije.

Upotreba:
• Podsetnik za zakazani servis
• Obaveštenje da je radnik na putu
• Promocije i sezonske akcije
• Status popravke

Paket → Marketing → SMS. Potrebno je dopuniti kredit za slanje.

Dostupno samo u Business paketu.`,
    type: 'info',
    category: 'Marketing',
    createdAt: '2026-01-15T11:00:00+02:00'
  },
  {
    id: 'feature-marketing-email',
    title: 'Email kampanje',
    message: `Kreirajte email poruke za grupe klijenata.

• Izbor primaoca po filterima (grad, tip usluge, poslednji posao)
• Šabloni za podsetnike i ponude
• Praćenje poslatih poruka
• Usklađeno sa saglasnošću za marketing (GDPR)

Dostupno samo u Business paketu.`,
    type: 'info',
    category: 'Marketing',
    createdAt: '2026-01-22T14:00:00+02:00'
  },
  {
    id: 'feature-teams',
    title: 'Timovi radnika',
    message: `Organizujte radnike u timove za veće projekte.

• Kreirajte tim (npr. „Ekipa A — klima")
• Dodelite više radnika jednom poslu
• Deljenje poslova i provizija unutar tima
• Pregled opterećenja po timu`,
    type: 'info',
    category: 'Timovi',
    createdAt: '2026-01-28T09:00:00+02:00'
  },
  {
    id: 'feature-whatsapp-viber',
    title: 'WhatsApp i Viber poruke',
    message: `Proširen marketing kanal — poruke preko WhatsApp-a i Viber-a.

Isti princip kao SMS:
• Podsetnici za termine
• Obaveštenja o statusu
• Brza komunikacija sa klijentom

Paket → Marketing → WhatsApp / Viber.

Dostupno samo u Business paketu.`,
    type: 'info',
    category: 'Marketing',
    createdAt: '2026-02-05T10:00:00+02:00'
  },
  {
    id: 'feature-loyalty',
    title: 'Program lojalnosti',
    message: `Dovedite nove firme u SpinTasker i dobijete mesec dana gratis.

Kod se generiše kao ime firme plus redni broj vaučera: 0001, 0002, 0003...

Kako radi:
1. Marketing → Loyalty — kopirajte kod (npr. FIRMA0001)
2. Novi korisnik ga unese pri registraciji
3. Vi dobijate 30 dana gratis pretplate

Svaki vaučer se koristi jednom. Novi kod dobija sledeći broj.

Marketing → Loyalty.`,
    type: 'success',
    category: 'Marketing',
    createdAt: '2026-02-12T11:00:00+02:00'
  },
  {
    id: 'feature-ai-business',
    title: 'AI poslovni asistent',
    message: `AI pomaže od prijave kvara do rada na terenu.

Ekstrakcija u formu za prijavu kvara iz:
• Slike (foto uređaja, nalepnica, tablica)
• Mejla klijenta
• Teksta / poruke
• Screenshot-a (kalendar, tabela, chat)

AI popunjava polja forme — vi proverite i sačuvate.

Asistencija radniku:
• Predlog dijagnoze i koraka na osnovu prijavljenog kvara
• Brži opis posla i preporuka postupka`,
    type: 'info',
    category: 'AI',
    createdAt: '2026-02-18T15:00:00+02:00'
  },
  {
    id: 'feature-ai-import',
    title: 'AI sekcija',
    message: `U meniju AI su četiri stavke.

AI Biznis
• Smernice po fazama (strategija, marketing, prodaja, operativa…)
• Svaka ideja ima konkretne korake
• Označite da pokrećete fazu ili je za sada preskačete
• Pratite napredak (npr. broj klijenata)

AI Import
• Otpremite slike ili dokumente (do 4)
• Ekstrahujte klijente sa slika — ime, telefon, adresa, email
• Ekstrahujte rezervne delove sa slika
• Pregledajte, ispravite i sačuvajte u bazu

AI Export
• AI izvoz podataka je u pripremi
• Do tada koristite izvoz u sekcijama Klijenti, Poslovi i Rezervni delovi

AI Podešavanja
• Izaberite model za import i ekstrakciju u formi posla
• Modeli su poređani od najslabijeg ka najjačem

AI sekcija (AI Biznis, AI Import, AI Export, AI Podešavanja) — dostupno u Business paketu.`,
    type: 'info',
    category: 'AI',
    createdAt: '2026-02-25T09:00:00+02:00'
  },
  {
    id: 'feature-tutorials',
    title: 'Tutorijali i video uputstva',
    message: `Učite korišćenje aplikacije kroz video tutorijale.

Gde pronaći:
• Tutorijali → Kako koristiti aplikaciju — video tutorijali
• Obaveštenja (ova stranica) — novosti od administracije
• Javna stranica /tutorials — isti snimci, uz komentare i pitanja

Preporučujemo novim korisnicima da prođu naše [tutorijale](tutorijali/kako-koristiti-app) na stranici.`,
    type: 'info',
    category: 'Pomoć',
    createdAt: '2026-03-10T10:00:00+02:00'
  },
  {
    id: 'feature-subscriptions',
    title: 'Pretplata',
    message: `Paket određuje šta koristite i koliko se naplaćuje.

Paketi:
• Free — probni period
• Starter — 19 € / mes.
• Standard — 39 € / mes.
• Business — 79 € / mes.
• Premium — 149 € / mes.

Promena paketa: Paket → izaberite plan.

Paket se može menjati samo prvih 10 dana u mesecu. Van tog roka ostajete na trenutnom paketu do sledećeg meseca.`,
    type: 'info',
    category: 'Pretplata',
    createdAt: '2025-11-03T12:41:00+01:00'
  },
  {
    id: 'feature-worker-mobile',
    title: 'Logovanje radnika u aplikaciju',
    message: `Radnici rade sa terena preko mobilne verzije.

Šta mogu:
• Videti dodeljene poslove za danas
• Menjati status (na putu, na lokaciji, završeno)
• Meriti vreme puta i rada
• Dodati slike, napomene i potpis klijenta
• AI dijagnoza na licu mesta

Pristup: radnik se prijavljuje sa emailom i lozinkom koje mu dodelite u panelu.`,
    type: 'success',
    category: 'Mobilno',
    createdAt: '2026-04-02T10:00:00+02:00'
  },
  {
    id: 'feature-activity-log',
    title: 'Log aktivnosti',
    message: `Tokom rada na intervenciji postoji log aktivnosti sa svim detaljima.

Na poslu se beleži:
• Ko je kreirao nalog i kada
• Ko je menjao podatke
• Promene statusa
• Predaja izveštaja

Sve je vezano za konkretnu intervenciju — ko, šta i kada.`,
    type: 'info',
    category: 'Bezbednost',
    createdAt: '2026-04-09T14:00:00+02:00'
  },
  {
    id: 'feature-user-management',
    title: 'Upravljanje korisnicima',
    message: `Više naloga unutar jedne kompanije.

Uloge:
• Admin — pun pristup
• Dispečer — poslovi i klijenti
• Radnik — terenska aplikacija

Profil → Upravljanje korisnicima → dodajte nalog i dodelite ulogu.`,
    type: 'info',
    category: 'Profil',
    createdAt: '2026-04-16T11:00:00+02:00'
  },
  {
    id: 'feature-realtime',
    title: 'Ažuriranja u realnom vremenu',
    message: `Promene se sinhronizuju odmah između svih uređaja.

Bez osvežavanja stranice vidite:
• Novi poslovi i izmene termina
• Status radnika na terenu
• Globalna obaveštenja od administracije
• Poruke u centru notifikacija

Tehnologija: WebSocket konekcija — indikator u uglu pokazuje da li ste povezani.`,
    type: 'info',
    category: 'Tehnologija',
    createdAt: '2026-05-07T10:00:00+02:00'
  },
  {
    id: 'feature-notes-section',
    title: 'Beleške i sistemska obaveštenja',
    message: `Ova stranica objedinjuje dve stvari:

Beleške — vaše lične interne beleške (čuvaju se lokalno u pregledaču).

Obaveštenja — hronološki pregled novina od SpinTasker tima, kao što čitate sada.

Od današnjeg dana nova obaveštenja stižu ovde automatski kada ih objavi super admin. Pročitana obaveštenja možete označiti jednim klikom.`,
    type: 'info',
    category: 'Obaveštenja',
    createdAt: '2026-06-25T09:00:00+02:00'
  },
  {
    id: 'feature-inventory-io',
    title: 'Ulazi i izlazi magacina',
    message: `Detaljna evidencija kretanja robe.

• Ulaz — nabavka od dobavljača
• Izlaz — izdavanje na posao ili prodaja
• Reversi — povrat neiskorišćenog materijala

Kompanija → Magacin → Ulazi / Izlazi / Reversi.`,
    type: 'info',
    category: 'Magacin',
    createdAt: '2026-07-09T10:00:00+02:00'
  },
  {
    id: 'feature-july-update',
    title: 'Jul 2026 — pregled i sledeći koraci',
    message: `Do danas (28. jul 2026.) SpinTasker pokriva kompletan ciklus terenskog servisa:

✓ Zakazivanje i kalendar
✓ Klijenti i istorija klijenta
✓ Radnici i timovi
✓ Statusi i Live praćenje u realnom vremenu
✓ Magacin, delovi i web prodavnica
✓ Arhiva i analitika
✓ Marketing (SMS, email, WhatsApp, Viber)
✓ AI asistent i uvoz podataka
✓ Ova stranica obaveštenja
✓ Logo @ — brzina prema opterećenju

Šta dalje?
Nova obaveštenja od administracije stižu ovde automatski. Proveravajte redovno ili pratite zvonce u gornjoj traci.

Hvala što koristite SpinTasker!`,
    type: 'success',
    category: 'Novosti',
    createdAt: '2026-07-28T10:00:00+02:00'
  }
];

export const generateFeatureTimeline = () =>
  FEATURE_TIMELINE_ITEMS.map((item) => ({
    _id: item.id,
    title: item.title,
    message: item.message,
    type: item.type,
    category: item.category,
    createdAt: item.createdAt
  })).sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

export default FEATURE_TIMELINE_ITEMS;
